import { base_url } from "../config";
import {
  ABOUTASSEMBLY,
  ABOUTASSEMBLYUPLOAD,
  ABOUTCONSTITUENCY,
  ABOUTCONSTITUENCYUPLOAD,
  SENDWHATSAPPMESSAGE,
  ADDASSEMBLY,
  ADDBOOTH,
  ADDCONSTITUENCY,
  ADDEVENT,
  ADDINFLUENCER,
  ADDPANCHAYAT,
  ADDUSER,
  ADDVOTER,
  ADDVOTERS,
  ADMINAPPOINTMENT,
  ALLCONSTITUENCY,
  ALLUSERROLES,
  ALLUSERS,
  APPOINTMENTGETOTP,
  APPOINTMENTLEADERS,
  APPOINTMENTROLES,
  APPOINTMENTSLOTS,
  APPOINTMENTVERIFYOTP,
  ASSEMBLYABOUT,
  ASSEMBLYABOUTBLOCK,
  ASSEMBLYABOUTBOOTH,
  ASSEMBLYABOUTPANCHAYAT,
  ASSEMBLYABOUTVILLAGE,
  ASSEMBLYANALYSISAC,
  ASSEMBLYANALYSISPC,
  ASSEMBLYBASEDADMIN,
  ASSEMBLYBASEDADMINID,
  ASSEMBLYBRIEFAC,
  ASSEMBLYBRIEFPC,
  ASSEMBLYDASHBOARD,
  ASSEMBLYELECTIONDETAILS,
  ASSEMBLYELECTIONDETAILSASSEMBLY,
  ASSEMBLYELECTIONDETAILSCONST,
  ASSEMBLYFROMCONSTITUENCY,
  BIRTHDAYWISH,
  BOOKAPPOINTMENT,
  CONSTELECTIONDETAILS,
  CONSTELECTIONDETAILSASSEMBLY,
  CONSTELECTIONDETAILSPARLIAMENT,
  CONSTGRAPHDETAILS,
  CONSTITUENCYBASEDADMIN,
  CONSTITUENCYBASEDADMINID,
  CONSTITUENCYBRIEFAC,
  CONSTITUENCYBRIEFPC,
  CONSTITUENCYDASHBOARD,
  CONSTITUENCYDETAILS,
  CREATEFORM,
  CREATEGRIEVANCE,
  DELETEEVENT,
  DELETEVOTER,
  DRAFT,
  EDITASSEMBLY,
  EDITBOOTH,
  EDITCONSTITUENCY,
  EDITPANCHAYAT,
  EDITUSER,
  EDITVOTER,
  FAMILYHEAD,
  FETCHEVENTS,
  GETADMINAPPOINTMENT,
  GETADMINID,
  GETADMINPANCHAYAT,
  GETALLASSEMBLY,
  GETALLBOOTHDETAILS,
  GETALLGRIEVANCE,
  GETALLVOTERS,
  GETASSEMBLY,
  GETASSIGNEDGRIEVANCE,
  GETBOOTH,
  GETBOOTHADMIN,
  GETBOOTHDETAILS,
  GETCONSTITUENCYGREIVANCE,
  GETDATAFROMSURVEY,
  GETFORM,
  GETFORMFROMID,
  GETGRIEVANCE,
  GETGRIEVANCES,
  GETINFLUENCER,
  GETPANCHAYAT,
  GETPANCHAYATADMIN,
  GETPANCHAYATGREIVANCE,
  GETPASTELECTIONDETAILS,
  GETVOTERS,
  GETVOTERSMESSAGE,
  GRAPGHVOTERASSEMBLY,
  GRAPGHVOTERCONSTITUENCY,
  GraphVotersAssembly,
  GRIEVANCEADDRESS,
  GET_ALL_ADMIN,
  ASSIGN_GRIEVANCE,
  NEWVOTER,
  PANCHAYATBASEDASSEMBLY,
  PANCHAYATBASEDASSEMBLYID,
  PANCHAYATDATA,
  SENDMESSAGE,
  SUBMITSURVEYDATA,
  SURVEYSTATUS,
  UPDATEEVENT,
  UPDATEGREIVANCESTATUS,
  UPLOADACDETAILS,
  UPLOADBULKASSEMBLY,
  UPLOADBULKBOOTH,
  UPLOADBULKCONSTI,
  UPLOADBULKPANCHAYAT,
  UPLOADDOC,
  UPLOADPASTDETAILS,
  UPLOADPCDETAILS,
  GET_ASSIGNED_GRIEVANCE,
  ASSEMBLYDETAILSDASHBOARD,
  BULKUSER,
  BULKEVENT,
  GETGRIEVANCEBYSTATUS,
  UPDATEGRIEVANCE,
  ADD_DRIVER,
  ADD_VEHICLE,
  GETALLDRIVER,
  EDITDRIVER,
  DELETE_DRIVER,
  GETALLVEHICLE,
  EDITVEHICLE,
  DELETE_VEHICLE,
  ADD_TRIP,
  GETALLTRIP,
  DELETETRIP,
  EDITTRIP,
  GET_VEHICLE,
  VEHICLE_ID,
  DRIVER_ID,
  DASHBOARD_TRIP,
  TRIPHISTORY,
  GETDISTRICT,
  GET_GP,
  GET_VILLAGE,
  GETTALUKA,
  GETSUBDISTRICT,
  GET_ALL_EMPLOYEE,
  CREATE_EMPLOYEE,
  GET_ALL_ASSET,
  ADD_ASSET,
  EDIT_ASSET,
  DELETE_ASSET,
  EDIT_EMPLOYEE,
  DELETE_EMPLOYEE,
  GET_FEEDBACK,
  ADD_FEEDBACK,
} from "../endpoint";
import {
  apiDelete,
  apiFilePost,
  apiFilePut,
  apiGet,
  apiPost,
  apiPut,
} from "../helpers/apiHelpers";

const PanchayathData = async () => {
  try {
    const response = await apiGet(`${base_url}${GETPANCHAYAT}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getPanchayat = async () => {
  try {
    const response = await apiGet(`${base_url}${GETPANCHAYATADMIN}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getPanchayatBasedAdmin = async () => {
  try {
    const response = await apiGet(`${base_url}${GETPANCHAYATADMIN}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getBoothBasedAdmin = async () => {
  try {
    const response = await apiGet(`${base_url}${GETBOOTHADMIN}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getAssemblyBasedAdmin = async () => {
  try {
    const response = await apiGet(`${base_url}${ASSEMBLYBASEDADMIN}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getConstituencyBasedAdmin = async () => {
  try {
    const response = await apiGet(`${base_url}${CONSTITUENCYBASEDADMIN}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getAssemblyBasedAdminId = async (id) => {
  try {
    const response = await apiGet(`${base_url}${ASSEMBLYBASEDADMINID}${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getConstituencyBasedAdminId = async (id) => {
  try {
    const response = await apiGet(
      `${base_url}${CONSTITUENCYBASEDADMINID}${id}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const getPanchayatBasedAdminId = async (id) => {
  try {
    const response = await apiGet(
      `${base_url}${PANCHAYATBASEDASSEMBLYID}${id}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const getConstituencyDetails = async () => {
  try {
    const response = await apiGet(`${base_url}${CONSTITUENCYDETAILS}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getAssemblyFromConstituency = async (id) => {
  try {
    const response = await apiGet(
      `${base_url}${ASSEMBLYFROMCONSTITUENCY}/${id}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const getAllVoters = async () => {
  try {
    const response = await apiGet(`${base_url}${GETALLVOTERS}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const GetVoters = async (data, id, skip, limit, type) => {
  try {
    const response = await apiGet(
      `${base_url}${GETVOTERS}?${type}=${id}&skip=${skip}&limit=${limit}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const GetVotersMessage = async (
  data,
  id,
  skip,
  limit,
  type,
  influencer,
  birthday,
  headOfFamily
) => {
  try {
    const response = await apiGet(
      `${base_url}${GETVOTERSMESSAGE}?${type}=${id}&skip=${skip}&limit=${limit}&influencer=${influencer}&birthday=${birthday}&headOfFamily=${headOfFamily}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const getInfluencers = async () => {
  try {
    const response = await apiGet(`${base_url}${GETINFLUENCER}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const GetBooth = async (data) => {
  try {
    const response = await apiPost(`${base_url}${GETBOOTH}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const GetBoothNumbers = async (data) => {
  try {
    const response = await apiGet(`${base_url}${GETBOOTHDETAILS}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const AddVoters = async (data) => {
  try {
    const response = await apiFilePost(`${base_url}${ADDVOTERS}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const AddVoter = async (data) => {
  try {
    const response = await apiPost(`${base_url}${ADDVOTER}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const getAllPanchayat = async () => {
  try {
    const response = await apiGet(`${base_url}${PANCHAYATDATA}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getAssemblyForPanchayat = async () => {
  try {
    const response = await apiGet(`${base_url}${GETASSEMBLY}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getPanchayatFromAssembly = async (data) => {
  try {
    const response = await apiPost(
      `${base_url}${PANCHAYATBASEDASSEMBLY}`,
      data
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const getAdminForPanchayat = async (name) => {
  try {
    const response = await apiGet(`${base_url}${GETADMINID}/${name}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const AddPanchayat = async (data) => {
  try {
    const response = await apiPost(`${base_url}${ADDPANCHAYAT}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const getAdminPanchayat = async () => {
  try {
    const response = await apiGet(`${base_url}${GETADMINPANCHAYAT}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getAllBoothDetails = async () => {
  try {
    const response = await apiGet(`${base_url}${GETALLBOOTHDETAILS}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const addBooth = async (data) => {
  try {
    const response = await apiPost(`${base_url}${ADDBOOTH}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const addAssembly = async (data) => {
  try {
    const response = await apiPost(`${base_url}${ADDASSEMBLY}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const editAssembly = async (id, data) => {
  try {
    const response = await apiPut(`${base_url}${EDITASSEMBLY}${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const editPanchayat = async (id, data) => {
  try {
    const response = await apiPut(`${base_url}${EDITPANCHAYAT}${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const editBooth = async (id, data) => {
  try {
    const response = await apiPut(`${base_url}${EDITBOOTH}${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const editVoter = async (id, data) => {
  try {
    const response = await apiPut(`${base_url}${EDITVOTER}${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const deleteVoter = async (id) => {
  try {
    const response = await apiDelete(`${base_url}${DELETEVOTER}${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getAllAssembly = async () => {
  try {
    const response = await apiGet(`${base_url}${GETALLASSEMBLY}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getAllConstituency = async () => {
  try {
    const response = await apiGet(`${base_url}${ALLCONSTITUENCY}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const addConstituency = async (data) => {
  try {
    const response = await apiPost(`${base_url}${ADDCONSTITUENCY}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const editConstituency = async (id, data) => {
  try {
    const response = await apiPut(`${base_url}${EDITCONSTITUENCY}${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const getAllUsers = async () => {
  try {
    const response = await apiGet(`${base_url}${ALLUSERS}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getAllUserRoles = async () => {
  try {
    const response = await apiGet(`${base_url}${ALLUSERROLES}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const addUser = async (data) => {
  try {
    const response = await apiPost(`${base_url}${ADDUSER}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const addBulkUser = async (data) => {
  try {
    const response = await apiPost(`${base_url}${BULKUSER}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const editUser = async (id, data) => {
  try {
    const response = await apiPut(`${base_url}${EDITUSER}${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const uploadBulkConstituency = async (data) => {
  try {
    const response = await apiFilePut(`${base_url}${UPLOADBULKCONSTI}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};
const uploadBulkAssembly = async (data) => {
  try {
    const response = await apiFilePut(`${base_url}${UPLOADBULKASSEMBLY}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};
const uploadBulkPanchayat = async (data) => {
  try {
    const response = await apiFilePut(
      `${base_url}${UPLOADBULKPANCHAYAT}`,
      data
    );
    return response;
  } catch (error) {
    throw error;
  }
};
const uploadBulkBooth = async (data) => {
  try {
    const response = await apiFilePut(`${base_url}${UPLOADBULKBOOTH}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const addInfluencer = async (id, data) => {
  try {
    const response = await apiPut(`${base_url}${ADDINFLUENCER}${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const NewVoter = async (id, data) => {
  try {
    const response = await apiPut(`${base_url}${NEWVOTER}${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const sendMessage = async (data) => {
  try {
    const response = await apiPost(`${base_url}${SENDMESSAGE}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const createForm = async (data) => {
  try {
    const response = await apiPost(`${base_url}${CREATEFORM}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const getAllForm = async () => {
  try {
    const response = await apiGet(`${base_url}${GETFORM}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getFormFromId = async (id) => {
  try {
    const response = await apiGet(`${base_url}${GETFORMFROMID}${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const updateSurveyStatus = async (id, data) => {
  try {
    const response = await apiPost(`${base_url}${SURVEYSTATUS}${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const submitSurveyData = async (id, data) => {
  try {
    const response = await apiPost(`${base_url}${SUBMITSURVEYDATA}${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};
const getDataFromSurveyId = async (id) => {
  try {
    const response = await apiGet(`${base_url}${GETDATAFROMSURVEY}${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const createGrievance = async (data) => {
  try {
    const response = await apiPost(`${base_url}${CREATEGRIEVANCE}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const updatedGrievance = async (grievanceId, data) => {
  try {
    const response = await apiPut(`${base_url}${UPDATEGRIEVANCE}/${grievanceId}`, data);
    return response;
  } catch (error) {
    console.error("Error updating grievance:", error);
    throw error;
  }
};

const getGrievance = async () => {
  try {
    const response = await apiGet(`${base_url}${GETGRIEVANCE}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getGrievancesByAdminId = async (adminId) => {
  try {
    const response = await apiGet(`${base_url}${GETGRIEVANCES}${adminId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getGrievanceByStatus = async (type) => {
  try {
    const response = await apiGet(`${base_url}${GETGRIEVANCEBYSTATUS}/${type}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getAssemblyGreivance = async () => {
  try {
    const response = await apiGet(`${base_url}${GET_ASSIGNED_GRIEVANCE}`);
    return response;
  } catch (error) {
    throw error;
  }
};
const getConstituencyGreivance = async (id, data) => {
  try {
    const response = await apiGet(`${base_url}${GET_ASSIGNED_GRIEVANCE}`, {});
    return response;
  } catch (error) {
    throw error;
  }
};
const getPanchayatGreivance = async (id) => {
  try {
    const response = await apiGet(`${base_url}${GETPANCHAYATGREIVANCE}${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const updateGreivanceStatus = async (id, data) => {
  try {
    const response = await apiPut(
      `${base_url}${UPDATEGREIVANCESTATUS}${id}`,
      data
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const getAllGrievance = async () => {
  try {
    const response = await apiGet(`${base_url}${GETALLGRIEVANCE}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const uploadPcDetails = async (details) => {
  const payload = {
    electionDetails: details.electionDetails,
  };
  try {
    const response = await apiPost(
      `${base_url}${UPLOADPCDETAILS}?year=${details.year}&panchayat=${details.panchayat}&assembly=${details.assembly}&election=${details.election}`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const uploadAcDetails = async (details) => {
  const payload = {
    electionDetails: details.electionDetails,
  };
  try {
    const response = await apiPost(
      `${base_url}${UPLOADACDETAILS}?year=${details.year}&panchayat=${details.panchayat}&assembly=${details.assembly}&election=${details.election}`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const getConstituencyEDAssembly = async (id, year) => {
  try {
    const response = await apiGet(
      `${base_url}${CONSTELECTIONDETAILSASSEMBLY}${id}?year=${year}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const getConstituencyEDConst = async (id, year) => {
  try {
    const response = await apiGet(
      `${base_url}${CONSTELECTIONDETAILSPARLIAMENT}${id}?year=${year}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const getAssemblyEDAssembly = async (id, year) => {
  try {
    const response = await apiGet(
      `${base_url}${ASSEMBLYELECTIONDETAILSASSEMBLY}${id}?year=${year}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const getAssemblyEDConstituency = async (id, year) => {
  try {
    const response = await apiGet(
      `${base_url}${ASSEMBLYELECTIONDETAILSCONST}${id}?year=${year}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const getAssemblyElectionPc = async (id, year) => {
  try {
    const response = await apiGet(
      `${base_url}${ASSEMBLYBRIEFPC}?id=${id}&year=${year}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const assemblyDetailsDashboard = async () => {
  try {
    const response = await apiGet(`${base_url}${ASSEMBLYDETAILSDASHBOARD}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getAssemblyElectionAc = async (id, year) => {
  try {
    const response = await apiGet(
      `${base_url}${ASSEMBLYBRIEFAC}?id=${id}&year=${year}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const getConstElectionPc = async (id, year) => {
  try {
    const response = await apiGet(
      `${base_url}${CONSTITUENCYBRIEFPC}?id=${id}&year=${year}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const getConstElectionAc = async (id, year) => {
  try {
    const response = await apiGet(
      `${base_url}${CONSTITUENCYBRIEFAC}?id=${id}&year=${year}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const uploadPastDetails = async (data, id) => {
  try {
    const response = await apiPost(
      `${base_url}${UPLOADPASTDETAILS}/${id}`,
      data
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const getPastElectionDetails = async (id, year, type) => {
  try {
    const response = await apiGet(
      `${base_url}${GETPASTELECTIONDETAILS}?assembly=${id}&year=${year}&typeOfElection=${type}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const getAssemblyAnalysisAc = async (id, year, votePercentage, position) => {
  try {
    const response = await apiGet(
      `${base_url}${ASSEMBLYANALYSISAC}/${id}?year=${year}&votePercentage=${votePercentage}&position=${position}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const getAssemblyAnalysisPc = async (id, year, votePercentage, position) => {
  try {
    const response = await apiGet(
      `${base_url}${ASSEMBLYANALYSISPC}/${id}?year=${year}&votePercentage=${votePercentage}&position=${position}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const uploadDoc = async (data) => {
  try {
    const response = await apiFilePost(`${base_url}${UPLOADDOC}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const AppointmentBook = async (id, data) => {
  try {
    const response = await apiPost(`${base_url}${BOOKAPPOINTMENT}/${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const AppointmentRoles = async () => {
  try {
    const response = await apiGet(`${base_url}${APPOINTMENTROLES}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const AppointmentLeaders = async (level) => {
  try {
    const response = await apiGet(`${base_url}${APPOINTMENTLEADERS}/${level}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const AppointmentSlots = async (id, date) => {
  try {
    const response = await apiGet(
      `${base_url}${APPOINTMENTSLOTS}?date=${date}&adminId=${id}`
    );

    return response;
  } catch (error) {
    throw error;
  }
};

const AdminAppointment = async (data) => {
  try {
    const response = await apiPost(`${base_url}${ADMINAPPOINTMENT}`, data);

    return response;
  } catch (error) {
    throw error;
  }
};

const getAdminAppointment = async (data) => {
  try {
    const response = await apiGet(`${base_url}${GETADMINAPPOINTMENT}`);

    return response;
  } catch (error) {
    throw error;
  }
};

const birthdayWish = async (data) => {
  try {
    const response = await apiPost(`${base_url}${BIRTHDAYWISH}`, data);

    return response;
  } catch (error) {
    throw error;
  }
};

const fetchEvents = async (type, data) => {
  try {
    const response = await apiPost(`${base_url}${FETCHEVENTS}/${type}`, data);

    return response;
  } catch (error) {
    throw error;
  }
};

const addEvent = async (data) => {
  try {
    const response = await apiPost(`${base_url}${ADDEVENT}`, data);

    return response;
  } catch (error) {
    throw error;
  }
};

const addBulkEvent = async (data) => {
  try {
    const response = await apiFilePost(`${base_url}${BULKEVENT}`, data);

    return response;
  } catch (error) {
    throw error;
  }
};

const updateEvent = async (id, data) => {
  try {
    const response = await apiPut(`${base_url}${UPDATEEVENT}/${id}`, data);

    return response;
  } catch (error) {
    throw error;
  }
};

const deleteEvent = async (id, data) => {
  try {
    const response = await apiDelete(`${base_url}${DELETEEVENT}/${id}`, data);

    return response;
  } catch (error) {
    throw error;
  }
};

const familyHead = async (id, data) => {
  try {
    const response = await apiPut(`${base_url}${FAMILYHEAD}/${id}`, data);

    return response;
  } catch (error) {
    throw error;
  }
};

const grievanceAddress = async () => {
  try {
    const response = await apiGet(`${base_url}${GRIEVANCEADDRESS}`);

    return response;
  } catch (error) {
    throw error;
  }
};

const getAllAdmin = async () => {
  try {
    const response = await apiGet(`${base_url}${GET_ALL_ADMIN}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const assignGrievance = async (grievanceId, adminId) => {
  try {
    const response = await apiPost(
      `${base_url}${ASSIGN_GRIEVANCE}/${grievanceId}`,
      {
        assignTo: adminId,
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

const assemblyDashboard = async () => {
  try {
    const response = await apiGet(`${base_url}${ASSEMBLYDASHBOARD}`);

    return response;
  } catch (error) {
    throw error;
  }
};

const constituencyDashboard = async () => {
  try {
    const response = await apiGet(`${base_url}${CONSTITUENCYDASHBOARD}`);

    return response;
  } catch (error) {
    throw error;
  }
};

const getDraft = async () => {
  try {
    const response = await apiGet(`${base_url}${DRAFT}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getVotersAssembly = async () => {
  try {
    const response = await apiGet(`${base_url}${GRAPGHVOTERASSEMBLY}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getVotersConstituency = async () => {
  try {
    const response = await apiGet(`${base_url}${GRAPGHVOTERCONSTITUENCY}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getAboutConstituency = async (id) => {
  try {
    const response = await apiGet(`${base_url}${ABOUTCONSTITUENCY}/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};
const getAboutAssembly = async (id) => {
  try {
    const response = await apiGet(`${base_url}${ABOUTASSEMBLY}/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getConstGraph = async () => {
  try {
    const response = await apiGet(`${base_url}${CONSTGRAPHDETAILS}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const assemblyAboutUpload = async (data) => {
  try {
    const response = await apiPost(`${base_url}${ABOUTASSEMBLYUPLOAD}`, data);

    return response;
  } catch (error) {
    throw error;
  }
};

const aboutAssembly = async () => {
  try {
    const response = await apiGet(`${base_url}${ASSEMBLYABOUT}`);

    return response;
  } catch (error) {
    throw error;
  }
};

const aboutAssemblyBlock = async (id) => {
  try {
    const response = await apiGet(`${base_url}${ASSEMBLYABOUTBLOCK}/${id}`);

    return response;
  } catch (error) {
    throw error;
  }
};

const aboutAssemblyPanchayat = async (id) => {
  try {
    const response = await apiGet(`${base_url}${ASSEMBLYABOUTPANCHAYAT}/${id}`);

    return response;
  } catch (error) {
    throw error;
  }
};

const aboutAssemblyBooth = async (id) => {
  try {
    const response = await apiGet(`${base_url}${ASSEMBLYABOUTBOOTH}/${id}`);

    return response;
  } catch (error) {
    throw error;
  }
};

const aboutAssemblyVillage = async (id) => {
  try {
    const response = await apiGet(`${base_url}${ASSEMBLYABOUTVILLAGE}/${id}`);

    return response;
  } catch (error) {
    throw error;
  }
};

const constituencyAboutUpload = async (data) => {
  try {
    const response = await apiPost(
      `${base_url}${ABOUTCONSTITUENCYUPLOAD}`,
      data
    );

    return response;
  } catch (error) {
    throw error;
  }
};

const addDriver = async (data) => { 
  try {
    const response = await apiPost(`${base_url}${ADD_DRIVER}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const addVehicle = async (data) => { 
  try {
    const response = await apiPost(`${base_url}${ADD_VEHICLE}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const getVehicle = async (data) => {
  try {
    const response = await apiGet(`${base_url}${GET_VEHICLE}`, data);
    return response;
  } catch (error) {
    throw error;
  }
}
const getAllVehicle = async (data) => { 
  try {
    const response = await apiGet(`${base_url}${GETALLVEHICLE}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};
const editVehicle = async (id,payload) => {
  try {
    const url = `${base_url}${EDITVEHICLE.replace(":id",id)}`;
    const response = await apiPut(url, payload);
    return response;
  } catch (error) {
    throw error;
  }
};
const deleteVehicle = async (id) => {
  try {
    const response = await apiDelete(`${base_url}${DELETE_VEHICLE.replace(":id",id)}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getDriver = async (data) => { 
  try {
    const response = await apiGet(`${base_url}${GETALLDRIVER}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};
export const editDriver = async ({ id, ...payload }) => {
  try {
    const url = `${base_url}${EDITDRIVER.replace(":id", id)}`;
    const response = await apiPut(url, payload);
    return response;
  } catch (error) {
    throw error;
  }
};
const deleteDriver = async (id) => {
  try {
    const response = await apiDelete(`${base_url}${DELETE_DRIVER.replace(":id", id)}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const addTrip = async (data) => {
  try {
    const response = await apiPost(`${base_url}${ADD_TRIP}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const getTrip = async (data) => {
  try {
    const response = await apiGet(`${base_url}${GETALLTRIP}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};
const editTrip = async (id, payload) => {
  try {
    const url = `${base_url}${EDITTRIP.replace(':id', id)}`;
    const response = await apiPut(url, payload);
    return response;
  } catch (error) {
    throw error;
  }
};
const deleteTrip = async (id) => {
  try {
    const response = await apiGet(`${base_url}${DELETETRIP.replace(':id', id)}`);
    return response;
  } catch (error) {
    throw error;
  }
};
// const getVehicleId = async (id) => {
//   try {
//     const response = await apiGet(`${base_url}${VEHICLE_ID}${id}`);
//     return response;
//   } catch (error) {
//     throw error;
//   }
// };
const getTripHistory = async (vehicleId,driverId) => {
  try {
    const response = await apiGet(`${base_url}${TRIPHISTORY}?vehicleId=${vehicleId}&driverId=${driverId}`);
    return response;
  } catch (error) {
    throw error;
  }
};
const dashboardForTrip = async (data) => {
  try {
    const response = await apiGet(`${base_url}${DASHBOARD_TRIP}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const sendWhatsAppMessage = async (data) => {
  try {
    const response = await apiPost(`${base_url}${SENDWHATSAPPMESSAGE}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const getDistrict = async () => {
  try {
    const response = await apiGet(`${base_url}${GETDISTRICT}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getSubDistrict = async (id) => {
  try {
    const response = await apiGet(`${base_url}${GETSUBDISTRICT.replace(":id", id)}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getTaluka = async (id) => {
  try {
    const response = await apiGet(
      `${base_url}${GETTALUKA.replace(":id", id)}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const getGp = async (id) => {
  try {
    const response = await apiGet(
      `${base_url}${GET_GP.replace(":id", id)}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const getVillage = async (id) => {
  try {
    const response = await apiGet(
      `${base_url}${GET_VILLAGE.replace(":id", id)}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const getAllEmployee = async () => {
  try {
    const response = await apiGet(
      `${base_url}${GET_ALL_EMPLOYEE}`
    );
    return response;
  } catch (error) {
    console.error("GET EMPLOYEE ERROR:", error?.response || error);
    throw error;
  }
};

const createEmployee = async (data) => {
  try {
    const response = await apiPost(
      `${base_url}${CREATE_EMPLOYEE}`,
      data
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const  createAsset = async (data) => {
  try {
    const response = await apiPost(
      `${base_url}${ADD_ASSET}`,
      data
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const getAssets = async () => {
  try {
    const response = await apiGet(
      `${base_url}${GET_ALL_ASSET}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const editAssets = async (id, payload) => {
  try {
    const url = `${base_url}${EDIT_ASSET.replace(':id', id)}`;
    const response = await apiPut(url, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

const deleteAssets = async (id) => {
  try {
     const payload = {
      status: false,
    };
    const response = await apiPut(`${base_url}${DELETE_ASSET.replace(':id', id)}`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};
const editEmployee = async (id, payload) => {
  try {
    const url = `${base_url}${EDIT_EMPLOYEE.replace(':id', id)}`;
    const response = await apiPut(url, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

const deleteEmployee = async (id) => {
  try {
    const payload = {
      status: false,
    };

    const url = `${base_url}${DELETE_EMPLOYEE.replace(":id", id)}`;
    return await apiPut(url, payload);
  } catch (error) {
    throw error;
  }
};


// ADD FEEDBACK
const addFeedback = async (payload) => {
  try {
    return await apiPost(`${base_url}${ADD_FEEDBACK}`, payload);
  } catch (error) {
    throw error;
  }
};

// GET ALL FEEDBACK
const getAllFeedback = async () => {
  try {
    return await apiGet(`${base_url}${GET_FEEDBACK}`);
  } catch (error) {
    throw error;
  }
};




const dataService = {
  uploadDoc,
  getAssemblyElectionAc,
  assemblyDetailsDashboard,
  sendWhatsAppMessage,
  getAssemblyElectionPc,
  getAssemblyAnalysisAc,
  getAssemblyAnalysisPc,
  PanchayathData,
  getPanchayat,
  getBoothBasedAdmin,
  GetVoters,
  GetVotersMessage,
  getInfluencers,
  GetBooth,
  AddVoters,
  AddVoter,
  getAllPanchayat,
  getAssemblyForPanchayat,
  getAdminForPanchayat,
  AddPanchayat,
  getAdminPanchayat,
  getAllBoothDetails,
  addBooth,
  getAllAssembly,
  GetBoothNumbers,
  addAssembly,
  editAssembly,
  editPanchayat,
  editBooth,
  getAllVoters,
  getPanchayatBasedAdmin,
  getAssemblyBasedAdmin,
  getPanchayatFromAssembly,
  getConstituencyBasedAdmin,
  getAssemblyBasedAdminId,
  getPanchayatBasedAdminId,
  getConstituencyBasedAdminId,
  getAssemblyFromConstituency,
  editVoter,
  deleteVoter,
  getAllConstituency,
  getConstituencyDetails,
  addConstituency,
  editConstituency,
  getAllUsers,
  getAllUserRoles,
  addUser,
  addBulkUser,
  addBulkEvent,
  editUser,
  uploadBulkConstituency,
  uploadBulkAssembly,
  uploadBulkPanchayat,
  uploadBulkBooth,
  addInfluencer,
  NewVoter,
  sendMessage,
  createForm,
  getAllForm,
  updateSurveyStatus,
  getFormFromId,
  submitSurveyData,
  getDataFromSurveyId,
  createGrievance,
  updatedGrievance,
  getGrievance,
  getGrievancesByAdminId,
  getGrievanceByStatus,
  getAssemblyGreivance,
  getPanchayatGreivance,
  getConstituencyGreivance,
  updateGreivanceStatus,
  getAllGrievance,
  uploadAcDetails,
  uploadPcDetails,
  getConstituencyEDAssembly,
  getConstituencyEDConst,
  getAssemblyEDAssembly,
  getAssemblyEDConstituency,
  getConstElectionAc,
  getConstElectionPc,
  uploadPastDetails,
  getPastElectionDetails,

  AppointmentBook,
  AppointmentRoles,
  AppointmentLeaders,
  AppointmentSlots,
  AdminAppointment,
  getAdminAppointment,
  birthdayWish,

  fetchEvents,
  addEvent,
  updateEvent,
  deleteEvent,
  familyHead,
  grievanceAddress,
  constituencyDashboard,
  assemblyDashboard,
  getDraft,
  getVotersAssembly,
  getVotersConstituency,
  getAboutAssembly,
  getAboutConstituency,
  getConstGraph,
  assemblyAboutUpload,
  constituencyAboutUpload,
  aboutAssembly,
  aboutAssemblyBlock,
  aboutAssemblyVillage,
  aboutAssemblyBooth,
  aboutAssemblyPanchayat,
  getAllAdmin,
  assignGrievance,

  addDriver,
  getDriver,
  editDriver,
  deleteDriver,
  addVehicle,
  getAllVehicle,
  getVehicle,
  editVehicle,
  deleteVehicle,
  addTrip,
  getTrip,
  editTrip,
  deleteTrip,
 getTripHistory,
  dashboardForTrip,

  getDistrict,
  getSubDistrict,
  getTaluka,
  getVillage,
  getGp,
  getAllEmployee,
  createEmployee,
  getAssets,
  createAsset,
  editAssets,
  deleteAssets,
  editEmployee,
  deleteEmployee,
   addFeedback,
  getAllFeedback,
};

export default dataService;
